function getBaseFolder(document) {
	if (document === 'page.legal') return 'legal'

	return false
}

export const pathResolver = (document, slug) => {
	const cleanSlug = slug?.replace(/^\//, '') ?? ''
	return getBaseFolder(document) ? `/${getBaseFolder(document)}/${cleanSlug}` : `/${cleanSlug}`
}
